import { useToast, useToastOptions } from "@chakra-ui/core"
import { useCallback } from "react";

interface returnType {
  error: (message?: string) => void,
  success: (message?: string) => void
}

const options: useToastOptions = {
  position: "top-right",
  duration: 4000,
  isClosable: true,
  status: "info"
};

export default function Toast(): returnType {
  const toast = useToast();

  const error = useCallback((message?: string): void => {
    toast({
      ...options,
      title: message || "Algo deu errado.",
      status: "error"
    })
  }, [toast]);

  const success = useCallback((message?: string): void => {
    toast({
      ...options,
      title: message || "Ação realizada com sucesso!",
      status: "success",
    })
  }, [toast]);

  return { error, success };
}